// Based on search find out items and if label is available, return label
export const getFilterItems = (filter, searchValue = '') => {
  const searchRe = new RegExp(
    searchValue.replace(/[*]/g, '.$&').replace(/[.+?^${}()|[\]\\]/g, '\\$&'),
    'i',
  );
  const listItems = filter.get('items').filter((item) => searchRe.test(item));
  const labels = filter.get('labels');
  return labels ? listItems.map((id) => filter.get('labels')[id]) : listItems;
};

// Find out items and if label is available, return label
export const getSelectedFilterItems = (filter) => {
  const labels = filter.get('labels');
  const selectedLabels = filter.get('selectedItems');
  return labels ? selectedLabels.map((id) => filter.get('labels')[id]) : selectedLabels;
};

export const tryMapIdsToLabels = ({ ids, labels }) => {
  if (!labels) {
    return ids;
  }

  const labelIds = Object.keys(labels);
  return ids
    .filter((id) => labelIds.includes(id))
    .map((id) => labels[id]);
};

export const tryMapLabelsToIds = ({ items, labels }) => {
  if (!labels) {
    return items;
  }

  return Object.entries(labels)
    // eslint-disable-next-line no-unused-vars
    .filter(([id, val]) => items.includes(val))
    .map(([id]) => id);
};

export const isBottomOfScreenReached = () => {
  const scrollTop = (
    (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop
  );
  const currentWindowPosition = scrollTop + window.innerHeight;
  return currentWindowPosition >= document.documentElement.scrollHeight;
};

/**
 * Prepare team labels
 * @param {{id: String, name: String}[]} teams
 * @returns {object}
 */
export const getTeamLabelsMap = (teams) => (
  teams.reduce((acc, team) => ({
    ...acc,
    [team.id]: team.name,
  }), {})
);
